import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ContentProvider } from "./context/ContentContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Team from "./components/Team";
import Achievements from "./components/Achievements";
import Gallery from "./components/Gallery";
import Services from "./components/Services";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Admin from "./pages/Admin";

const Landing = () => (
  <main className="bg-white text-black antialiased" data-testid="landing-page">
    <Header />
    <Hero />
    <About />
    <Team />
    <Achievements />
    <Gallery />
    <Services />
    <Contact />
    <Footer />
  </main>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ContentProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </ContentProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
